export default __webpack_public_path__ + "static/media/33.1224f83c.jpg";